import styled from 'styled-components';

export const Container = styled.textarea`
  border: 1px solid ${({theme}) => theme.colors.gray[400]};
  border-radius: 8px;

  padding: 12px 16px;
  font-weight: 400;
  font-size: 12px;

  outline: none;

  width: 100%;
  height: 100%;

  resize: none;
`;
